import clsx, { ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * 合并 className（含 Tailwind 冲突合并）
 *
 * - 先使用 clsx 处理条件 class
 * - 再使用 tailwind-merge 进行原子类冲突合并
 */
export function cname(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * 生成指定长度的十六进制 UUID 片段
 *
 * @param length 期望长度
 * @returns 由 [0-9a-f] 组成的随机字符串
 */
export const generateUUID = (length: number) => {
  let d = new Date().getTime()
  const uuid = ''.padStart(length, 'x').replace(/[xy]/g, c => {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : (r & 0x7) | 0x8).toString(16)
  })
  return uuid
}
